import { MODULE_LAYOUTS } from '@coursera-web/cds-labs';

import type { SearchProductHit } from 'bundles/search-common/providers/searchTypes';

import BackgroundImage from 'images/front-page/google-refresh-spotlight.png';

import _t from 'i18n!nls/search-common';

type CollectionSets = {
  collectionTitle: string;
  collectionId: string;
  entries: SearchProductHit[];
}[];
export const GOOGLE_AI_CAMPAIGN_CERTIFICATE_SLUGS = [
  'google-data-analytics',
  'google-digital-marketing-ecommerce',
  'google-it-support',
  'google-project-management',
  'google-ux-design',
  'google-cybersecurity',
];
export const getGoogleAIRefreshProducts = (searchHits: SearchProductHit[] | undefined) => {
  const googleAIProducts = searchHits?.filter((product) => {
    if (product?.url) {
      return GOOGLE_AI_CAMPAIGN_CERTIFICATE_SLUGS.some((slug) => product.url?.endsWith(slug));
    }
    return false;
  });
  return googleAIProducts;
};

export const getMerchandisingInSearchCollectionsData = (
  mostPopularElements: SearchProductHit[] | undefined,
  isLoading?: boolean
) => {
  const collectionSets: CollectionSets = [];
  const googleAIProducts = getGoogleAIRefreshProducts(mostPopularElements)?.slice(0, 2);
  const firstProductName = googleAIProducts?.[0]?.translatedName || googleAIProducts?.[0]?.name;
  collectionSets.push({
    collectionId: 'merchandising-in-search',
    collectionTitle: _t('Merchandising In Search'),
    entries: googleAIProducts || [],
  });
  return {
    headline:
      googleAIProducts?.length === 2
        ? _t('Popular certificates, new AI skills')
        : _t(`New - learn how #{firstProductName} uses AI`, { firstProductName }),
    description:
      googleAIProducts?.length === 2
        ? _t('Build in-demand skills to start your new career—now with practical AI training.')
        : _t('Get job-ready with Google Professional Certificates—now including AI skills.'),
    isCollectionsLoading: isLoading,
    collectionSets,
    layout: googleAIProducts?.length === 2 ? MODULE_LAYOUTS.text4image8 : MODULE_LAYOUTS.text6image6,
    ctaText: _t('View all'),
    ctaTarget: '/google-career-certificates',
    showCtaArrowIcon: true,
    backgroundImage: {
      width: 800,
      url: BackgroundImage,
      description: '',
    },
    numOfResults: googleAIProducts?.length ?? 0,
  };
};
